import { useCallback, useEffect, useRef, useState } from "react";
import { getCommunityDiscussion } from "../../services/communityService";
import { MastermindEditModel } from "./models/MastermindEditModel";

export const useMastermindId = (id?: string | number) => {
    const isMountedRef = useRef(true);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState<MastermindEditModel | null>(null);
    const [error, setError] = useState<Error | boolean | null>(null);

    useEffect(() => {
        isMountedRef.current = true;
        return () => {
            isMountedRef.current = false;
        }
    }, []);

    const load = useCallback(async () => {
        if(!id)
            return;
        try {
            setData(null);
            setLoading(true);
            const _data = await getCommunityDiscussion(`${id}`);
            if(!isMountedRef.current)
                return;
            if(!!_data)
                setData(_data);
        }
        catch (error) {
            setError(error as Error ?? true);
        }
        finally {
            if(!isMountedRef.current)
                return;
            setLoading(false);
        }
    }, [id]);

    useEffect(() => {
        load();
    }, [load]);

    return { data, loading, error }

}